import { render, staticRenderFns } from "./SectionSponsorship.vue?vue&type=template&id=2402bf46&scoped=true&"
import script from "./SectionSponsorship.vue?vue&type=script&lang=js&"
export * from "./SectionSponsorship.vue?vue&type=script&lang=js&"
import style0 from "./SectionSponsorship.vue?vue&type=style&index=0&id=2402bf46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402bf46",
  null
  
)

export default component.exports